var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStar48Line = function SvgIconStar48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.813 39.06a2.9 2.9 0 0 1-2.85-3.4l1.24-7.25-5.29-5.13a2.91 2.91 0 0 1 1.6-5l7.34-1.06 3.28-6.61a2.869 2.869 0 0 1 2.6-1.61 2.87 2.87 0 0 1 2.59 1.61l3.29 6.61 7.33 1.06a2.9 2.9 0 0 1 1.6 5l-5.29 5.13 1.25 7.25a2.902 2.902 0 0 1-4.2 3.06l-6.57-3.43-6.57 3.43a2.85 2.85 0 0 1-1.35.34Zm-3.8-17.52 5.21 5a1.73 1.73 0 0 1 .49 1.51l-1.23 7.14 6.46-3.38a1.74 1.74 0 0 1 1.57 0l6.47 3.38-1.23-7.14a1.67 1.67 0 0 1 .49-1.51l5.21-5-7.21-1a1.7 1.7 0 0 1-1.28-.92l-3.23-6.52-3.23 6.52a1.7 1.7 0 0 1-1.28.92l-7.21 1Z",
    fill: "current"
  })));
};
export default SvgIconStar48Line;